<summa-details-tile-widget
  [title]="'common:dictionary.user_plural' | i18nextCap"
  [route]="{ destination: ['user-management'], tooltip: 'common:dictionary.view-all' | i18nextCap }"
  [totalCountLabel]="['reseller:users.widget.total-count' | i18nextCap, sandbox.userCount$ | async].join(' ')"
></summa-details-tile-widget>
